/* This file is autogenerated, see readme.md for instructions */
import SecurityShieldSvgIcon from '@bloomreach/banana-theme/icons/security-shield.svg?react';
import { forwardRef } from 'react';

import Icon from '../icon';

import type { ReactNode, Ref } from 'react';

import type { IconInstanceProps } from '../icon.types';

const SecurityShieldIcon = forwardRef((props: IconInstanceProps, forwardedRef: Ref<SVGSVGElement>): ReactNode => {
  return (
    <Icon {...props} ref={forwardedRef}>
      <SecurityShieldSvgIcon />
    </Icon>
  );
});

SecurityShieldIcon.displayName = 'SecurityShieldIcon';

export default SecurityShieldIcon;
